import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  SimpleLocationModel
} from 'app/restricted/suppliers/supplier-single-solution/supplier-single-solution.component';

@Component({
  selector: 'app-generic-chip-manager',
  templateUrl: './generic-chip-manager.component.html',
  styleUrls: ['./generic-chip-manager.component.scss']
})
export class GenericChipManagerComponent implements OnInit {

  @Input() items: any = [];
  @Input() tags: string[] = null;
  @Output() outputTags = new EventEmitter<string[]>();

  constructor() {
  }

  ngOnInit() {

    if (this.tags) {
      for (let i = 0; i < this.tags.length; i++) {
        this.items.push(new SimpleLocationModel(this.tags[ i ], this.tags[ i ]));
      }
    }

    this.tags = [];
  }

  remove(id: string): void {
    this.items = this.items.filter(item => item[ 'id' ] != id);
    this.tags = this.tags.filter(item => item != id);
    this.outputTags.emit(this.tags);
  }

}
